<template>
  <div class="main">
    <el-card>
      <div class="flex mb-40">
        <div style="width: 700px">
          <el-steps :active="active" align-center>
            <el-step title="选择试卷"></el-step>
            <el-step title="发布考试"></el-step>
          </el-steps>
        </div>
        <el-button v-if="active == 1" size="small" type="primary" @click="next">配置考试信息</el-button>
        <el-button v-if="active == 2" size="small" @click="active = 1">上一步</el-button>
      </div>
    </el-card>
    <el-card style="margin-top: 5px" v-if="active == 1">
      <div class="text-title">请选择一张试卷</div>
      <el-form>
        <el-row>
          <el-col :span="10">
            <el-form-item label="试卷名称：">
              <el-input v-model="courseForm.name" style="width: 200px" placeholder="请输入试卷名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="试卷分类：">
              <el-select v-model="courseForm.categoryId" placeholder="请选择试卷分类">
                <el-option v-for="item in courseOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <div class="form-btn-box">
              <el-button type="primary" @click="search()"> <i class="el-icon-search" style="margin-right: 5px"></i>查询 </el-button>
              <el-button @click="search('refresh')"> <i class="el-icon-refresh" style="margin-right: 5px"></i>重置 </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <dy-table
        v-loading="tableLoading"
        ref="textTable"
        tableHeight="300"
        style="margin-top: 12px"
        :columns="infoColumns"
        :table-data="textList"
        element-loading-text="加载中"
        rowKeyName="uKey"
        dragClassName="drag-class"
        :total="total"
        :page-num="currentPage"
        :page-size="10"
        @current-change="onCurrentChange"
        @selection-change="onSelectionChange"
      >
      </dy-table>
    </el-card>
    <el-card style="margin-top: 5px" v-if="active == 2">
      <el-form ref="infoForm" label-position="right">
        <el-form-item label="考试名称：">
          <el-input v-model="infoForm.name" placeholder="请输入考试名称"></el-input>
        </el-form-item>
        <el-form-item label="及格分数：">
          <el-input v-model="infoForm.score" placeholder="请输入及格分数"></el-input>
        </el-form-item>
        <el-form-item label="考试封面：">
          <el-upload :action="uploadImg" name="file" :show-file-list="false" :headers="headers" drag :on-success="(res) => imgSuccess(res, 'image')">
            <div v-if="!infoForm.image">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </div>
            <div v-else class="image-container">
              <img class="img-style" :src="infoForm.image" alt="" />
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div class="box box-align-center box-pack-end mt-btns" style="margin-top: 12px; margin-right: 30px">
        <el-button type="primary" plain v-if="active == 2" @click="infoSave()">保存</el-button>
        <el-button type="danger" plain @click="goExam">取消</el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
import DyTable from '@/components/common/dytable';
import host from '@/api/index';
import { platformPaperList, saveExam, detailExam } from '@/api/index';
import { encrypt, decrypt } from '@/api/common_encrypt';
import { formatDate } from '@/utils/utils';
export default {
  components: {
    DyTable,
  },
  data() {
    return {
      examId: null,
      tableLoading: false,
      currentPage: 1,
      total: 0,
      active: 1,
      courseForm: {},
      infoForm: {},
      examForm: {},
      infoColumns: [],
      courseOptions: [],
      textList: [],
    };
  },
  mounted() {
    this.examId = this.$route.query.id;
    if (this.examId) {
      this.editArticle();
    }
    this.infoColumns = [
      {
        type: 'selection',
        width: '55',
      },
      {
        type: 'index',
        title: '序号',
        index: this.addIndex,
      },
      {
        key: 'paperName',
        title: '试卷名称',
      },
      {
        key: 'categoryName',
        title: '试卷分类',
      },
      {
        key: 'creatorName',
        title: '创建人',
      },
      {
        key: 'createTime',
        title: '创建时间',
      },
      {
        key: '',
        title: '操作',
        width: 300,
        render: ({ row }) => {
          return (
            <div>
              <el-link type='primary' style='margin-left:12px' onClick={() => this.textAdd(row)}>
                预览
              </el-link>
            </div>
          );
        },
      },
    ];
    this.getList();
  },
  computed: {
    uploadImg() {
      return host.uploadImgUrl;
    },
    headers() {
      return {
        'bg-token': localStorage.getItem('token'), // 直接从本地获取token就行
      };
    },
  },
  methods: {
    onSelectionChange(val) {
      console.log('val', val);
      if (val) {
        this.examForm = val[0];
      }
    },
    goExam() {
      this.$router.push('/examManage');
    },
    editArticle() {
      let info = {
        id: this.examId,
      };
      console.log(info);
      var data = encrypt(JSON.stringify(info));
      detailExam(data).then((res) => {
        if (res.result == 1) {
          var ress = JSON.parse(decrypt(res.data));
          console.log('编辑专题', ress);
          this.infoForm = ress;
        } else {
          that.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
      });
    },
    infoSave() {
      var info = {
        paperName: this.examForm.paperName,
        paperId: this.examForm.id,
        paperSchoolId: this.examForm.schoolId,
        ...this.infoForm,
      };
      console.log(info, '我是表单');
      var data = encrypt(JSON.stringify(info));
      saveExam(data).then((res) => {
        if (res.result == 1) {
          // var ress = JSON.parse(decrypt(res.data.replace(/[\r\n]/g, '')));
          console.log(res);
          this.$message({
            showClose: true,
            message: '保存成功',
            type: 'success',
          });
          this.$router.push('/examManage');
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
      });
    },
    imgSuccess(file, key) {
      console.log(key, file);
      // this.courseForm[key] = file.data.url;
      this.$set(this.infoForm, key, file.data.url);
    },
    next() {
      if (this.active++ > 1) this.active = 1;
    },
    // 分页
    onCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    getList() {
      this.tableLoading = true;
      let info = {
        page: this.currentPage,
        pageSize: 10,
        isTemplate: 0,
        publishStatus: 1,
        ...this.courseForm,
      };
      console.log(info);
      var data = encrypt(JSON.stringify(info));
      platformPaperList(data).then((res) => {
        if (res.result == 1) {
          var ress = JSON.parse(decrypt(res.data));
          console.log('列表====>', ress);
          this.total = ress.total;
          this.currentPage = ress.pageNum;
          this.textList = ress.list.map((item) => {
            return {
              ...item,
              createTime: item.createTime ? formatDate(new Date(item.createTime), 'yyyy-MM-dd hh:mm:ss') : '',
            };
          });
          this.tableLoading = false;
          this.chapterTableLoading = false;
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.el-tabs__item {
  min-width: 100px;
  text-align: center;
  padding: 0;
}

/deep/.el-dropdown {
  margin-right: 10px;
}

// /deep/.el-tabs__header {
//     margin: 0;
// }

.main-top {
  padding: 20px 15px;
  border-bottom: 1px solid rgba(96, 98, 102, 0.2392);

  .mti-txt {
    white-space: nowrap;
  }
}

.main-middle {
  padding: 15px 11px;
}

.common-btns {
  padding: 0 22px 33px;
}
.text-title {
  font-weight: 500;
  font-size: 25px;
  margin-bottom: 15px;
}
</style>
